export default __webpack_public_path__ + "static/media/1489.48ebe944.png";